import React, { useState } from "react";
import {
  Button,
  Edit,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useNotify,
  useRedirect,
} from "react-admin";
import { HelpPageForm } from "./HelpPageForm";
import { BackButton } from "../../../components/common/BackButton";
import { HelpButton } from "../../../components/common/HelpButton";
import { CopyIcon } from "../../../components/common/iconography";
import { deepRedirect } from "../../../utils/utils";
import { FilePaths } from "../../../utils/constants";
import {
  saveHelpPageContentFile,
  saveRemoveFiles,
} from "../../../utils/fileUtils";
import { logError } from "../../../utils/appUtils";
import DeepDeleteButton from "./DeepDeleteButton";

const CloneButton = ({ history, backPath, data, resource }) => {
  const handleClone = () => {
    deepRedirect(history, `/${resource}/create`, backPath, {
      clone: data,
    });
  };

  return (
    <Button label="Clone" size="small" color="primary" onClick={handleClone}>
      <CopyIcon />
    </Button>
  );
};

const EditActions = (props) => (
  <TopToolbar>
    <HelpButton />
    <CloneButton {...props} />
    <BackButton {...props} />
  </TopToolbar>
);

const EditToolbar = ({ record, resource, basePath, ...props }) => {
  const [loading, setLoading] = useState(false);
  const notify = useNotify();
  const redirect = useRedirect();

  const transform = async (data) => {
    setLoading(true);
    const newData = { ...data, updatedBy: window.appUser?.fullName };

    try {
      if (newData.kbFiles || record?.kbFiles) {
        await saveRemoveFiles(
          record,
          newData,
          "kbFiles",
          `${FilePaths.KB_FILES}/${newData.topic}`
        );
      }
      if (newData.kbMedia || record?.kbMedia) {
        await saveRemoveFiles(
          record,
          newData,
          "kbMedia",
          `${FilePaths.KB_MEDIA}/${newData.topic}`
        );
      }
      await saveHelpPageContentFile(record, newData);
    } catch (error) {
      setLoading(false);
      logError("helpPages:HelpPageEdit:transform", error, notify);
      return Promise.reject(error);
    }

    return newData;
  };

  const handleSuccess = () => {
    notify("Help page updated successfully", "success");
    setLoading(false);
    redirect("list", basePath);
  };

  const handleFailure = (error) => {
    setLoading(false);
    logError("helpPages:HelpPageEdit:onFailure", error, notify);
  };

  return (
    <Toolbar
      style={{ justifyContent: "space-between" }}
      {...props}
      saving={loading}
    >
      <SaveButton
        disabled={props.pristine}
        transform={transform}
        onSuccess={handleSuccess}
        onFailure={handleFailure}
      />
      <DeepDeleteButton
        loading={loading}
        setLoading={setLoading}
        record={record}
        resource={resource}
        basePath={basePath}
      />
    </Toolbar>
  );
};

export const HelpPageEdit = (props) => {
  return (
    <Edit
      {...props}
      title="Edit Help Page"
      mutationMode="pessimistic"
      actions={<EditActions {...props} />}
    >
      <SimpleForm submitOnEnter={false} toolbar={<EditToolbar {...props} />}>
        <HelpPageForm {...props} />
      </SimpleForm>
    </Edit>
  );
};
